export const DRAYAGE = 'drayage';
export const INTERMODAL = 'intermodal';

const modes = [
  DRAYAGE,
  INTERMODAL,
];

export default modes;
